import script from "./BurgerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BurgerCard.vue?vue&type=script&setup=true&lang=js"

import "./BurgerCard.vue?vue&type=style&index=0&id=dd706c7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd706c7e"]])

export default __exports__